import {ADD_ORGANIZATION_FAILED,ADD_ORGANIZATION_SUCCESS,ADD_ORGANIZATION,
  GET_ORGANIZATION_DETAIL,GET_ORGANIZATION_DETAIL_FAILED,GET_ORGANIZATION_DETAIL_SUCCESS,UPDATE_ORGANIZATION_DETAIL,
  UPDATE_ORGANIZATION_DETAIL_FAILED,UPDATE_ORGANIZATION_DETAIL_SUCCESS,
  ORGANIZATION_DETAIL_GET_IP_LOCATION,ORGANIZATION_DETAIL_GET_IP_LOCATION_FAILED,ORGANIZATION_DETAIL_GET_IP_LOCATION_SUCCESSFULL,
ORGANIZATION_DETAIL_GET_STATE,ORGANIZATION_DETAIL_GET_STATE_FAILED,ORGANIZATION_DETAIL_GET_STATE_SUCCESSFULL,
ORGANIZATION_DETAIL_GET_COUNTRY,ORGANIZATION_DETAIL_GET_COUNTRY_FAILED,ORGANIZATION_DETAIL_GET_COUNTRY_SUCCESSFULL,
ORGANIZATION_DETAIL_GET_LIST,ORGANIZATION_DETAIL_GET_LIST_SUCCESSFULL,ORGANIZATION_DETAIL_GET_LIST_FAILED,
ORGANIZATION_DETAIL_DELETE,ORGANIZATION_DETAIL_DELETE_SUCCESSFULL,ORGANIZATION_DETAIL_DELETE_FAILED
  } from './actionTypes';
    
    const initialState = {
      loading: false,
      organizationDetail:null,
      organizationError:null,
      organizationSuccess:null,
      organizationDetailSuccess:null,
      updateDetail:null
    }
    
    const RecruiterOrganizationReducer = (state = initialState, action) => {
      
      switch (action.type) {
        
        //add organization
        case ADD_ORGANIZATION:
          state = {
            ...state,
            loading: true,
            organizationDetail: null,
            organizationSuccess: null,
            organizationError: null,
          }
          break
        case ADD_ORGANIZATION_SUCCESS:
          state = {
            ...state,
            loading: false,
            organizationError: null,
            organizationSuccess: action.payload,
           }
          break
        case ADD_ORGANIZATION_FAILED:
         
          state = {
            ...state,
            loading: false,
            organizationSuccess: null,
            organizationError: action.payload,
          }
          break
        
        //get  organization detail
        case GET_ORGANIZATION_DETAIL:
          state = {
            ...state,
            loading: true,
            organizationDetail: null,
            organizationDetailSuccess: null,
            organizationError: null,
          }
          break
        case GET_ORGANIZATION_DETAIL_SUCCESS:
          state = {
            ...state,
            loading: false,
            organizationError: null,
            organizationDetailSuccess: action.payload,
          }
          break
        case GET_ORGANIZATION_DETAIL_FAILED:
        
          state = {
            ...state,
            loading: false,
            organizationDetailSuccess: null,
            organizationError: action.payload,
          }
          break
          //update  organization detail
        case UPDATE_ORGANIZATION_DETAIL:
          state = {
            ...state,
            loading: true,
            updateDetail: null,
            organizationError: null,
          }
          break
        case UPDATE_ORGANIZATION_DETAIL_SUCCESS:
          state = {
            ...state,
            loading: false,
            organizationError: null,
            updateDetail: action.payload,
          }
          break
        case UPDATE_ORGANIZATION_DETAIL_FAILED:
        
          state = {
            ...state,
            loading: false,
            updateOrganizationDetail: null,
            organizationError: action.payload,
          }
          break
          case ORGANIZATION_DETAIL_GET_COUNTRY:
      state = {
        ...state,
        setCountryData: null,
        setCountryDataError: null,
        loading:true
      }
      break
    case ORGANIZATION_DETAIL_GET_COUNTRY_SUCCESSFULL:
      state = {
        ...state,
        setCountryData: action.payload,
        loading:false
      }
      break
    case ORGANIZATION_DETAIL_GET_COUNTRY_FAILED:
      state = {
        ...state,
        setCountryDataError: action.payload,
        loading:false
      }
      break

      case ORGANIZATION_DETAIL_GET_STATE:
      state = {
        ...state,
        setStatesData: null,
        setStatesDataError: null,
        loading:true
      }
      break
    case ORGANIZATION_DETAIL_GET_STATE_SUCCESSFULL:
      state = {
        ...state,
        setStatesData: action.payload,
        loading:false
      }
      break
    case ORGANIZATION_DETAIL_GET_STATE_FAILED:
      state = {
        ...state,
        setStatesDataError: action.payload,
        loading:false
      }
      break

      case ORGANIZATION_DETAIL_GET_IP_LOCATION:
      state = {
        ...state,
        setIplocation: null,
        setIplocationError: null,
        loading:true
      }
      break
    case ORGANIZATION_DETAIL_GET_IP_LOCATION_SUCCESSFULL:
      state = {
        ...state,
        setIplocation: action.payload,
        loading:false
      }
      break
    case ORGANIZATION_DETAIL_GET_IP_LOCATION_FAILED:
      state = {
        ...state,
        setIplocationError: action.payload,
        loading:false
      }
      break
      case ORGANIZATION_DETAIL_GET_LIST:
      state = {
        ...state,
        organizationDetail: null,
        organizationError: null,
        loading:true
      }
      break
      case ORGANIZATION_DETAIL_GET_LIST_SUCCESSFULL:
        state = {
          ...state,
          organizationDetail: action.payload,
          organizationError: null,
          loading:false
        }
        break
      case ORGANIZATION_DETAIL_GET_LIST_FAILED:
      state = {
        ...state,
        organizationDetail: null,
        organizationError: action.payload,
        loading:false
      }
      break
      case ORGANIZATION_DETAIL_DELETE:
      state = {
        ...state,
        organizationDetail: null,
        organizationError: null,
        loading:true
      }
      break
      case ORGANIZATION_DETAIL_DELETE_SUCCESSFULL:
      state = {
        ...state,
        organizationDetail: action.payload,
        organizationError: null,
        loading:true
      }
      break
      case ORGANIZATION_DETAIL_DELETE_FAILED:
        state = {
          ...state,
          organizationDetail:null,
          organizationError: action.payload,
          loading:true
        }
        break
        default:
          state = { ...state }
          break
      }
      return state
    }
    
    export default RecruiterOrganizationReducer
    